import store from '../../store';
import { previewExploreBiteById } from '../../store/explore/explore.slice';

const openPreviewInspirationBite = (biteId: number) => {
  const biteIdAsNumber = Number(biteId);
  store.dispatch(previewExploreBiteById(biteIdAsNumber));
};
export default openPreviewInspirationBite;
